import sizes from './sizes'
import colors from './colors'

export default {
  SP_LIGHT: {
    fontFamily: "'Univers Light Normal', sans-serif",
    fontSize: sizes.DEFAULT_FONT_SIZE,
    color: colors.MAIN_COLOR,
    fontWeight: '300'
  },
  SP_REGULAR: {
    fontFamily: 'Univers Black',
    fontSize: sizes.DEFAULT_FONT_SIZE,
    color: colors.MAIN_COLOR,
    fontWeight: '400'
  },
  SP_BOLD: {
    fontFamily: 'UniversLTStd Bold',
    fontSize: sizes.DEFAULT_FONT_SIZE,
    color: colors.MAIN_COLOR,
    fontWeight: '700'
  },
  SP_SEMIBOLD: {
    fontFamily: 'UniversLTStd',
    fontSize: sizes.DEFAULT_FONT_SIZE,
    color: colors.MAIN_COLOR,
    fontWeight: '600'
  }
}
